/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Error_Name_RequiredInputs */



/**
* | output |
* | --- |
* | "Share name cannot be empty." |
*
* @param {Team_Share_Error_Name_RequiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_error_name_required = /** @type {((inputs?: Team_Share_Error_Name_RequiredInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Error_Name_RequiredInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le nom du partage ne peut pas être vide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Freigabename darf nicht leer sein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il nome della condivisione non può essere vuoto.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имя общего ресурса не может быть пустым.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El nombre compartido no puede estar vacío.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("股票名称不能为空。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有名は空にできません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर का नाम खाली नहीं हो सकता।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("O nome da ação não pode estar vazio.")
	return /** @type {LocalizedString} */ ("Share name cannot be empty.")
});